import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { actionOverlay } from '../../store/Overlay';
import { ContentContainer } from '../Layout/ContentContainer';
import { Screen } from '../Layout/Screen';
import Logo from '../Logo';
import Close from '../CloseBtn';
import LineLink from '../LineLink';
import Hyperlink from '../Hyperlink';

// Assets
import { brandColors, device } from '../../styles/variables';
import close from '../../assets/images/close.png';
import flower from '../../assets/images/brand_botanical.png';

const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: url(${flower}) no-repeat;
  background-size: 120%;
  background-position: center;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  z-index: 5;
`;

const StyledScreen = Screen.extend`
  width: 100%;
  height: auto;
  min-height: 100% !important;
  background: ${brandColors.orange};
`;

const ContentHolder = styled.div`
  position: relative;
  margin-right: 17px;
  z-index: 6;
`;

const MenuClose = styled(Close)`
  top: 19px;
  width: 23px;
  height: 20px;
  right: 49px;
  @media ${device.tablet} {
    top: 48px;
    right: 100px;
    height: 33.48px;
    width: 36px;
  }
`;

const Content = ContentContainer.extend`
  height: auto;
`;

const Menu = styled.div`
  padding: 56px 20px;

  .split {
    @media ${device.mobileL} {
      display: inline-block;
      vertical-align: top;
      width: unset;
      margin: 0 25px 0 0;
    }
    @media ${device.tablet} {
      margin: 0 10% 0 0;
    }
    @media ${device.laptopL} {
      margin: 0 100px 0 0;
    }

    :last-child {
      margin: 0;
    }
  }
`;

class MenuOverlay extends React.PureComponent {
  animation() {}

  render() {
    const { overlay, closeOverlay } = this.props;

    const address = (
      <span>
        The Printworks,<br />7 Blake Mews, Kew,<br />London, TW9 3GA<br />
        <Hyperlink linkName="020&nbsp;8334&nbsp;7860" linkAddress="tel:02083347860" />
      </span>
    );

    return (
      <StyledScreen>
        <BackgroundOverlay />
        <ContentHolder>
          <Logo />
          <MenuClose
            src={close}
            alt="Close overlay"
            onClick={() => closeOverlay({ opened: false, overlayType: overlay.overlayType })}
            overlayType={overlay.overlayType}
          />
          <Content>
            <Menu>
              <div className="split">
                <LineLink
                  subtitle="read about us"
                  linkText="who are we?"
                  linkColor={brandColors.blue}
                  route="/about-us"
                  active
                  lineBreak
                  tinyV
                />
                <LineLink
                  subtitle="see our services"
                  linkText="how do we do it?"
                  linkColor={brandColors.blue}
                  route="/services"
                  active
                  lineBreak
                  tinyV
                />
              </div>
              <div className="split">
                <LineLink
                  subtitle="see case studies"
                  linkText="making of an industry leader"
                  linkColor={brandColors.blue}
                  route="/making-of-an-industry-leader"
                  lineBreak
                  tinyV
                  active
                />
                <LineLink
                  linkText="a new hope in dermatology"
                  linkColor={brandColors.blue}
                  route="/advocating-for-patients-hope"
                  listV
                  tinyV
                  active
                />
                <LineLink
                  linkText="bridging the gap"
                  linkColor={brandColors.blue}
                  route="/bridging-the-gap"
                  listV
                  tinyV
                  active
                />
              </div>
              <div className="split">
                <LineLink
                  className="menuLineLinks"
                  subtitle={address}
                  linkText="contact us"
                  linkColor={brandColors.blue}
                  route="/contact"
                  active
                  lineBreak
                  tinyV
                />
              </div>
              <div className="split">
                <div className="menuLineLinks">
                  <LineLink
                    subtitle="geeky legals"
                    linkText="privacy"
                    linkColor={brandColors.blue}
                    route="/privacy"
                    active
                    lineBreak
                    tinyV
                  />
                  <LineLink
                    linkText="cookies"
                    linkColor={brandColors.blue}
                    route="/cookies"
                    active
                    lineBreak
                    tinyV
                  />
                </div>
              </div>
            </Menu>
          </Content>
        </ContentHolder>
      </StyledScreen>
    );
  }
}

MenuOverlay.defaultProps = {
  overlay: {}
};

MenuOverlay.propTypes = {
  overlay: PropTypes.object,
  closeOverlay: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  overlay: state.overlay
});

const mapDispatchToProps = dispatch => ({
  closeOverlay(overlayState) {
    dispatch(actionOverlay(overlayState));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuOverlay);



// WEBPACK FOOTER //
// ./src/components/Overlay/MenuOverlay.jsx